import { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { editWorkerCategory } from './WorkersAPI.jsx';

export default function EditExtraWorkCategory({ show, onHide, jwt, id, onUpdate, category }) {

    const [categoryLocal, setCategoryLocal] = useState({ ...category });

    const onSubmit = async () => {

        const response = await editWorkerCategory(id, jwt, categoryLocal.name);

        if (response) {
            onUpdate(categoryLocal);
            onHide();
            return;
        }
        alert('Не удалось изменить. Попробуйте позже');
    }


    return <Modal
        centered
        show={show}
        onHide={onHide}
    >
        <Form onSubmit={e => e.preventDefault() || onSubmit()}>
            <Modal.Header closeButton>
                <Modal.Title>Изменить категорию</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Новое название</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        value={categoryLocal.name}
                        onChange={(e) => { setCategoryLocal({ ...categoryLocal, name: e.target.value }) }}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { onHide() }}><span>Закрыть</span></Button>
                <Button variant="success" type="submit"><span>Сохранить</span></Button>
            </Modal.Footer>
        </Form>
    </Modal>
}
